import { EventEmitter } from '@angular/core';
import { BaseError } from '../messages/base-error';
import { BaseViewModel } from './base-view-model';
import { PropertyViewModelPropertyChangedEventArgs } from './property-view-property-changed-event-args';
import { BehaviorSubject } from 'rxjs';
import { SourceMessage } from '@nts/std/types';
import { MessageContainer } from './message-container';
import { BasePropertyViewModelInterface } from './base-property-view-model.interface';

export abstract class BasePropertyViewModel extends BaseViewModel implements BasePropertyViewModelInterface {

  protected _metadataDescription: string = '';
  protected _metadataShortDescription: string = '';

  propertyName: string;
  propertyViewModelChanged: EventEmitter<void> = new EventEmitter<void>();
  modelChanged: EventEmitter<void> = new EventEmitter<void>();
  propertyChanged: EventEmitter<PropertyViewModelPropertyChangedEventArgs> = new EventEmitter<PropertyViewModelPropertyChangedEventArgs>();
  metadataDescription$ = new BehaviorSubject<string>(this._metadataDescription);
  metadataShortDescription$ = new BehaviorSubject<string>(this._metadataShortDescription);

  override get isRequired() {
    return this.internalIsRequired;
  }

  override get hasErrors(): boolean {
    return this.messageContainerCollection.length > 0;
  }

  override get isVisible() {
    return this._isVisible;
  }
  override set isVisible(value: boolean) {
    if (this._isVisible !== value) {
      this._isVisible = value;
      this.onPropertyChanged('isVisible');
      this.isVisible$.next(value);
    }
  }

  get bindedValuePropertyName() {
    return 'value';
  }

  get propertyPath() {
    return '';
  }

  get metadataDescription() {
    return this._metadataDescription;
  }
  set metadataDescription(value: string) {
    if (this._metadataDescription !== value) {
      this._metadataDescription = value;
      this.onPropertyChanged('metadataDescription');
      this.metadataDescription$.next(value);
    }
  }

  get metadataShortDescription() {
    return this._metadataShortDescription;
  }
  set metadataShortDescription(value: string) {
    if (this._metadataShortDescription !== value) {
      this._metadataShortDescription = value;
      this.onPropertyChanged('metadataShortDescription');
      this.metadataShortDescription$.next(value);
    }
  }

  constructor(name: string) {
    super();
    this.propertyName = name;
  }

  override onDestroy() {
    super.onDestroy();

    // disabillitato destroy per evitare che si rompino i MS della versione REL_11_0_X, dalla versione successiva è abilitato
    return;

    this.propertyViewModelChanged?.complete();
    this.modelChanged?.complete();
    this.propertyChanged?.complete();

    this.metadataDescription$?.complete();
    this.metadataShortDescription$?.complete();

    this.propertyViewModelChanged = null;
    this.modelChanged = null;
    this.propertyChanged = null;

    this.metadataDescription$ = null;
    this.metadataShortDescription$ = null;
  }

  override getErrors(): Array<string> {
    return this.errors$.value;
  }

  onPropertyChanged(propertyName: string = null) {
    const args = new PropertyViewModelPropertyChangedEventArgs();
    args.propertyName = propertyName;
    this.propertyChanged.emit(args);
  }

  addErrorMessageIfNotExist(err: BaseError, sourceMessage: SourceMessage, emitOnAddMessageInViewModel = true) {
    // verifica che non ci sia già un errore con lo stesso codice e propertyname
    if (!this.messageContainerCollection.find(x => x.contains(err))) {
      this.messageContainerCollection.splice(0, 0, MessageContainer.fromBaseAndSourceMessage(err, sourceMessage, this.uniqueId));
      if (this.hasEventDispatcher() && emitOnAddMessageInViewModel) {
        this.eventDispatcher.onAddMessageInViewModel.next({ viewModel: this, messages: [err] });
      }
      this.updateCurrentErrors();
      this.onErrorStatusChanged.next();
    }
  }
}